// Field label PDFs for the Toro Max. FIELD_LABELS_WORDS.md section 8 (2026-10-23, after Robert's print tests).
//
// The Toro Max driver holds one paper size for a whole print job (the 8:45 AM test cut PNL-01 off a 1 x 2),
// so each file holds one size. Every page is exactly one label at that size: landscape, length x height.
// Black text on the yellow tape, no border (9:27 AM). Text holds its height for the material and is centered;
// it shrinks only to fit the length, and the page flags anything past the 10% shrink before it gets here.
//
// Driver: the GP size the card names (driver-page.ts). 0.5 x 1.5, 1 x 2 and 1 x 4 are driver sizes as they are.
// A 2 x 9 label sits centered on GP 2 x 12 (QR_ROLL_1X3_WORDS.md rev 2). Scale Default.

import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { CAP_HEIGHT, fitOf, type LabelSize } from "./field-labels";
import { shiftPage, START_OFFSET, type PrinterOffset } from "./printer-offset";
import { driverPage } from "./driver-page";

/** One page per label, all at one size, in the order given, moved by this iPad's field roll offset. */
export async function fieldLabelsPdf(texts: readonly string[], size: LabelSize, offset: PrinterOffset = START_OFFSET.fieldRoll): Promise<Uint8Array> {
  if (!texts.length) throw new Error("No labels to print.");
  const pdf = await PDFDocument.create();
  pdf.setTitle(`SafeTag Field Labels ${size.height} x ${size.length} in`);
  pdf.setCreator("SafeTag Field Labels");
  const font = await pdf.embedFont(StandardFonts.HelveticaBold);
  // The page is the driver's. The text centers on it, so it sits centered in the label the same as before.
  const W = driverPage(size.height, size.length).length * 72;
  const H = size.height * 72;
  for (const text of texts) {
    const page = pdf.addPage([W, H]);
    const { points } = fitOf(text, size);
    const w = font.widthOfTextAtSize(text, points);
    page.drawText(text, {
      x: (W - w) / 2,
      y: (H - CAP_HEIGHT * points) / 2,
      size: points,
      font,
      color: rgb(0, 0, 0),
    });
    shiftPage(page, offset);
  }
  return pdf.save();
}
